import { dispatchAction } from '@ardoq/rxbeach';
import { addSlideToNewOrExistingPresentation } from 'presentationEditor/presentationChooser/actions';
import { toVisualizationSlide } from 'presentationEditor/newSlideFromContext';
import { trackExportingVisualization } from 'tracking/events/visualizations';
import { TrackingExportFormat } from '@ardoq/export';
import { ViewIds } from '@ardoq/api-types';

if (module.hot) {
  module.hot.accept();
}

export const addToPresentation = (
  viewId: ViewIds,
  isViewpointMode: boolean
) => {
  trackExportingVisualization({
    name: viewId,
    format: TrackingExportFormat.PRESENTATION,
    isViewpointMode,
  });
  dispatchAction(addSlideToNewOrExistingPresentation(toVisualizationSlide()));
};
